<template>
    <div>
        <div class="col-12 mt-5">
            <div>
                {{ service.service.title_NL }}<br />
                {{ $t('reservation.details.accommodation.accommodation', {type: service.supplierType}) }}
            </div>
        </div>
        <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
            <small class="pl-2">{{ $t('reservation.details.accommodation.occupation') }}</small>
            <core-lever
                class="ml-3 pt-1"
                :label="$t('reservation.details.accommodation.show-data-to-customer')"
                labelClass="ml-2"
                :value="item.showData"
                @input="(isChecked) => item.showData = isChecked"
            ></core-lever>
            <core-lever
                class="ml-3 pt-1"
                :label="$t('reservation.details.accommodation.show-prices-to-customer')"
                labelClass="ml-2"
                :value="item.showPrices"
                @input="(isChecked) => item.showPrices = isChecked"
            ></core-lever>
        </div>
        <div class="col-12" v-if="prices">
            <reservation-details-accommodation-type
                :key="stockCounter"
                :passengers="passengers"
                :selectedClass="selectedClass"
                :selectedRoomType="selectedRoomType"
                :selectedRoomsAmount="selectedRoomsAmount"
                :dataIsFilling="dataIsFilling"
                :service="item.service"
                :isFreeSale="service.supplierType === 'Free sale' || !service.stock"
                :arrivalDate="service.dateFrom"
                :departureDate="service.dateUntil"
                :prices="getDefaultTypePrices"
                :selectedTypes="item.reservationLines"
                :bedsBookingReference="item.bedsBookingReference"
                :statusCode="item.statusCode"
                :reservationId="item.id"
                :bedsHotelCode="item.service.bedsHotelCode"
                :customRoomsAmount.sync="item.customRoomsAmount"
                @amountChanged="updateTravelersRoomType"
                @occupancyLoaded="setOccupancyLoaded"
                @customRoomsAmountChanged="customRoomsAmountChanged"
            >
          </reservation-details-accommodation-type>
        </div>
        <div class="col-12 mt-2">
            <div class="d-flex row align-items-between">
                <div class="col">
                    <span class="total-price-description">{{ $t('reservation.details.accommodation.total-price-description') }}</span>
                </div>
                <div class="col-3 d-flex row align-items-center">
                    <core-money-input class="total-price-amount" :key="getSubTotal + ''" readonly :amount="getSubTotal"></core-money-input>
                </div>
            </div>
        </div>
        <!-- <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
            <small class="pl-2">{{ $t('reservation.details.accommodation.travelers') }}</small>
        </div>
        <div class="mt-1 col-12">
            <reservation-details-accommodation-travelers
                :key="travelersKey"
                :reservationLineId="getReservationLineId()"
                :serviceId="service.serviceId"
                :travelers.sync="passengers"
                :placements="placements"
                @roomsChosen="roomsChosen"
            >
            </reservation-details-accommodation-travelers>
        </div> -->
        <div v-if="((item.actionDate && item.actionDate !== 'NaN-NaN-NaN') || actionDateCalculated) && item.statusCode === 'TODO'" class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
          <small v-if="(item.actionDate && item.actionDate !== 'NaN-NaN-NaN')" class="green-text pl-2">Active action date: <strong>{{ formattedActionDate }}</strong> <button class="btn-custom-send white-text" @click="clearActionDate(item)">&#x2715;</button></small>
          <small v-if="(!item.actionDate || item.actionDate === 'NaN-NaN-NaN') && actionDateCalculated" class="red-text pl-2">Inactive action date: <strong>{{ actionDateCalculated }}</strong> <button class="btn-custom-send white-text" @click="activateActionDate(item)">&#10003;</button></small>
        </div>
        <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
            <small class="pl-2">{{ $t('reservation.details.accommodation.notes') }}</small>
        </div>
        <div class="col-12 mt-2">
            <textarea class="form-control" rows="3" v-model="item.notes"></textarea>
        </div>
        <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
          <small class="pl-2">{{ $t('reservation.details.accommodation.day-to-day-text') }}</small>
        </div>
        <div class="col-12 mt-2">
          <core-editor
            ref="newNoteEditor"
            class="col-sm-12 mb-2"
            v-model="item.dayToDayText"
          ></core-editor>
        </div>
        <div class="col-12 mt-2" v-if="item.statusCode === 'DONE'">
          {{ $t('reservation.booking-date') }}:<br/>
          <core-calendar
            :key="item.bookingDate"
            :date.sync="item.bookingDate"
            :masks="{input: 'DD/MM/YYYY'}"
            :inputProps="{
              placeholder: $t('reservation.booking-date')
            }"
          ></core-calendar>
        </div>
        <div v-if="item.statusCode === 'PENDING'">
          <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
            <small class="pl-2">{{ $t('reservation.booking-mail-sent-date') }}</small>
          </div>
          <div class="col-12 mt-2">
            <input class="form-control" type="text" readonly :value="item.bookingMailSentDate" />
          </div>
        </div>
        <div v-if="item.statusCode === 'DECLINED'">
          <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
            <small class="pl-2">{{ $t('reservation.booking-mail-declined-date') }}</small>
          </div>
          <div class="col-12 mt-2">
            <input class="form-control" type="text" readonly :value="item.bookingMailAnswerDate" />
          </div>
        </div>
        <div class="col-12 mt-2"><label><input type="checkbox" v-model="item.automaticallyBooked"> {{ $t('reservation.automatically-booked') }}</label></div>
        <reservation-details-media-box :reservationLineId="item.id" />
        <div class="col-12 mt-2" v-if="prompt">
          <small class="pl-2">{{ $t('reservation.details.accommodation.prompt') }}:</small>
          <textarea class="form-control" rows="10" v-model="prompt"></textarea>
        </div>
    </div>
</template>

<script>
import { rlProps } from '@/mixins/reservationLineProperties'
export default {
  mixins: [rlProps]
}
</script>

<style scoped>
  div >>> .btn {
    text-transform: capitalize;
    font-style: italic;
  }
  div >>> .btn:hover,
  div >>> .btn {
    text-decoration: none;
  }
  div >>> .btn.active {
    border: 0;
    font-weight: bold;
    font-family: "Open Sans Bold";
    font-style: normal;
    box-shadow: none !important;
  }
  div >>> .btn.btn-link {
    color: #767676 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservation/details/Accommodation.vue